// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Menu from 'components/Menu/Menu'
import Link from 'components/Link/Link'

const logoUrl = siteData.images_url + 'logo/AnimationCoop_Logo-Colour.svg'

class HeaderPrimary extends React.Component {
	render() {
		const { match } = this.props

		return (
			<header className="header">
				<div className="-chickens">
					<Link to="/">
						<img src={ `${siteData.images_url}header/anicoop-chickens.png` } alt="" />
					</Link>
				</div>

				<div className="-inner">
					<div className="logo">
						<Link to="/">
							<img src={ logoUrl } alt="Animation Coop" />
						</Link>
					</div>

					<Menu match={ match } />
				</div>
			</header>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( HeaderPrimary )



// WEBPACK FOOTER //
// ./components/HeaderPrimary/HeaderPrimary.jsx